/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React, { useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import authStyles from "../../theme/authStyles";
import i18n from "../../services/i18n";
import { logoutUser } from "../../services/auth";

const useStyles = makeStyles(authStyles);

const Logout = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    // code to run on component mount
    setTimeout(() => {
      dispatch(logoutUser());
    }, 500);
  }, [dispatch]);

  return (
    <div className={classes.signetOutText}>
      <Grid container spacing={4} className={classes.alignAuthPage}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h3" className={classes.signedOut}>
            {i18n.t("core:signedOut")}
          </Typography>
          <Typography component="p" className={classes.signedOutDescription}>
            {i18n.t("core:signedOutDescription")}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
});

export default Logout;
